import { FormulaUnlinker } from '../helpers/formulaUnlinker';
import { runFullCleanup } from '../helpers/functionCleanup';
import { log } from './logger';
export async function unlinkAlphaCells() {
    try {
        const result = await FormulaUnlinker.getInstance().unlinkSelectedRangeAlphaFormulas();
        log.info('Alpha selected range unlink result', result);
        await runFullCleanup();
    }
    catch (error) {
        log.error('Error unlinking alpha cells', error);
    }
}
export async function unlinkAlphaWorksheet() {
    try {
        const result = await FormulaUnlinker.getInstance().unlinkActiveWorksheetAlphaFormulas();
        log.info('Alpha worksheet unlink result', result);
        await runFullCleanup();
    }
    catch (error) {
        log.error('Error unlinking alpha worksheet', error);
    }
}
export async function unlinkAlphaWorkbook() {
    try {
        const result = await FormulaUnlinker.getInstance().unlinkWorkbookAlphaFormulas();
        log.info('Alpha workbook unlink result', result);
        await runFullCleanup();
    }
    catch (error) {
        log.error('Error unlinking alpha workbook', error);
    }
}
//# sourceMappingURL=alphaUnlink.js.map